import { DURATION_OPTIONS } from "../../pages/ProductAnalyzer/common/DurationFilter";
import { INBOUND_PLACEMENT_TYPES, INIT_PANELS, Panel } from "../../constants";
import { ISettingsState } from "./settings.types";

export const initialState: ISettingsState = {
  general: {
    inboundShipping: 0,
    inboundPlacement: INBOUND_PLACEMENT_TYPES[0],
    storageTime: 0,
    fulfilment: "FBA",
    prepFee: 0,
    miscFee: 0,
    miscFeePercent: 0,
    autoOpenExtension: true,
  },
  productAnalyzer: {
    minBsr: 1,
    maxBsr: 100,
    minProfit: 0,
    minRoi: 0,
    defaultRanksAndPricesTimeFrame: DURATION_OPTIONS[0].id,
    defaultBbAnalysisTimeFrame: DURATION_OPTIONS[1].id,
    defaultFbmCost: 0,
    defaultCustomRoiCalc: 0,
    showProfitInQuickInfo: true,
    showProfitMarginInQuickInfo: true,
    showRoiInQuickInfo: true,
    showBreakevenInQuickInfo: true,
    showOfferSummaryInQuickInfo: true,
    showAveragePricingInQuickInfo: true,
    defaultAverageTimeFrameInQuickInfo: DURATION_OPTIONS[0].id,
    defaultBBAverageTimeFrameInQuickInfo: DURATION_OPTIONS[0].id,
    showPricesChart: true,
    showSoldChart: true,
    showOffersChart: true,
    defaultChartTimeSpan: "OneMonth",
    panelOrder: Object.keys(INIT_PANELS).map((key) => ({
      ...INIT_PANELS[key as unknown as Panel],
      id: key as unknown as Panel,
    })),
    tags: [],
    showJumpButtons: false,
  },
};
